export default "__VITE_ASSET__DimFkQZE__"